export default __webpack_public_path__ + "static/media/bancontact.bd4115f0.svg";